import { render } from "./index.vue?vue&type=template&id=08149d46&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=08149d46&lang=scss&scoped=true"

import exportComponent from "E:\\Code\\Github\\Wuguojie-AviationTeach\\AviationTeach-PPT\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08149d46"]])

export default __exports__